import React from "react"
import { useTranslation } from "react-i18next"

import { RoomAirVolumeInput } from "./RoomAirVolumeInput"

export interface RoomSupplyAirInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomSupplyAirInput = React.memo(
  ({ hideLabel, autoFocus }: RoomSupplyAirInputProps) => {
    const { t } = useTranslation()
    return (
      <RoomAirVolumeInput
        name="room.sup"
        className="room-form__supply-air"
        label={t("Room.sup")}
        unit="m³/h"
        color="#99d7dc"
        hideLabel={hideLabel}
        autoFocus={autoFocus}
        testId="room__supply-air__input"
      />
    )
  }
)
